import * as React from 'react';

import { type MarketingStatusTag, topAiProgramColors } from 'bundles/product-card/components/utils/marketingTagUtils';
import Badge from 'bundles/unified-description-page-common/components/shared/badges/Badge';

type Props = {
  marketingTag: MarketingStatusTag;
};

const TopAiProgramBadge = ({ marketingTag }: Props) => {
  return <Badge color={topAiProgramColors}>{marketingTag.tag}</Badge>;
};

export default TopAiProgramBadge;
